/* eslint-disable import/no-cycle */

// import { push } from 'react-router';
import { call, put, takeEvery, select } from 'redux-saga/effects';
import validateItems from './editCommand/validate';
import { stock, commands } from '../../api/api';
import logger from '../../utils/logger';

import { displaySuccess, displayLoading } from '../../utils/toast/Toast';

import {
  GET_EAN_FROM_STOCK_MANAGER,
  ADD_EAN_FROM_STOCK_MANAGER,
  ADD_WARNING_REFERENCE_EXIST,
  CHECK_IF_REFERENCE_ALREADY_EXIST,
  CREATE_BATCH,
  HANDLE_LOADER,
  CREATE_BATCH_SUCCESS,
  BIND_OFFER_CODE,
  BIND_OFFER_CODE_SAGA
} from './actions';

import { ADD_CHECKED_COMMANDS_IDS } from '../commands/commandsActions';

const getCommands = state => state.importCommands.commands;

export function* getEanFromStockManager(action) {
  yield put({ type: HANDLE_LOADER, data: true });
  try {
    const response = yield call(stock.getProducts, action.payload);
    if (response.data.success === true) {
      yield put({ type: ADD_EAN_FROM_STOCK_MANAGER, data: response.data });
      const currentCommands = yield select(getCommands);
      currentCommands.forEach((command, commandIndex) => {
        validateItems(command, { commandIndex });
      });
    }
  } catch (error) {
    logger(error);
  }
}

export function* checkIfExternalReferenceExist(action) {
  try {
    const response = yield call(
      commands.checkIfReferenceAlreadyExist,
      action.payload
    );
    if (response.data.success === true) {
      yield put({ type: ADD_WARNING_REFERENCE_EXIST, data: response.data });
      const currentCommands = yield select(getCommands);
      currentCommands.forEach((command, commandIndex) => {
        validateItems(command, { commandIndex });
      });
    }
  } catch (error) {
    logger(error);
  }
}

export function* createBatch(action) {
  const closeLoading = displayLoading(`Création des commandes en cours`);
  yield put({ type: HANDLE_LOADER, data: true });
  try {
    const response = yield call(commands.createBatch, action.payload);
    if (response.data.success === true) {
      displaySuccess('Commandes importées avec succès');
      yield put({ type: CREATE_BATCH_SUCCESS, data: response.data });
      if (!action.payload.commands[0].readyToBePickedUp) {
        yield put({ type: ADD_CHECKED_COMMANDS_IDS, data: response.data });
      }
    }
  } catch (error) {
    logger(error);
  } finally {
    yield put({ type: HANDLE_LOADER, data: false });
    closeLoading();
  }
}

export function* bindOffer(action) {
  yield put({ type: BIND_OFFER_CODE, data: action.payload });
  const currentCommands = yield select(getCommands);
  currentCommands.forEach((command, commandIndex) => {
    validateItems(command, { commandIndex });
  });
}

const importCommandsSaga = [
  takeEvery(GET_EAN_FROM_STOCK_MANAGER, getEanFromStockManager),
  takeEvery(CHECK_IF_REFERENCE_ALREADY_EXIST, checkIfExternalReferenceExist),
  takeEvery(CREATE_BATCH, createBatch),
  takeEvery(BIND_OFFER_CODE_SAGA, bindOffer)
];

export default importCommandsSaga;
